/**
 * ExclusiveModule — admin OS surface for the /exclusive (Maison) pillar.
 *
 * Bespoke commissions · florists, tailors, jewellers, galleries,
 * wine merchants, boutiques. The most relationship-heavy pillar.
 */
import React from "react";
import Placeholder from "@/pages/admin/os/Placeholder";

export default function ExclusiveModule() {
  return (
    <Placeholder
      title="Exclusive · Maison · Admin"
      phase="Phase 2"
      testid="os-modules-exclusive"
      description="Bespoke commissions · the Concierge®'s relationship network. Florists, tailors, jewellers, galleries, wine merchants, boutiques. Brief queue lives in Operate → Requests."
      willInclude={[
        "Maison directory CRUD (founder-vetted houses per city + category)",
        "Voice-line editor (review Haiku 4.5 output, stamp source=desk)",
        "Member whisper threshold tuning (per category)",
        "Maison brief queue & sourcing workflow",
        "Cross-pillar pairing rules (e.g. florist + restaurant for anniversary)",
      ]}
    />
  );
}
